export enum ImageDisplayMode {
  ALWAYS_CAROUSEL = "Always Carousel",
  MASONRY_ON_LARGE_SCREENS = "Masonry on large screens",
}
